<template>
    <div class="mt-2">
        <div v-if="shouldDisplayPXFMention && pxfLegalMentionsText">
          <span class="font-weight-bold small" v-html="pxfLegalMentionsText" />
        </div>
        <p class="small">
            <sup class="d-table-cell">1&nbsp;</sup>
            <span class="d-table-cell">{{ dasDescription }}</span>
        </p>
    </div>
</template>

<script>
export default {
    name: "das-pxf-description",
    props: {
        dasDescription: {
            type: String,
            required: true,
            default: "DAS description"
        },
        shouldDisplayPXFMention: {
          type: Boolean,
          required: false
        },
        pxfLegalMentionsText: {
          type: String,
          required: false
        }
    }
}
</script>

<style scoped>

</style>
